
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 24 24","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M8.854 15.146c1.788 1.788 4.15 3.065 5.985 3.867 1.227.536 2.68.195 3.719-.843l1.108-1.109-3.367-2.29-.68.681c-.434.434-1.11.696-1.816.494-.785-.226-2.217-.795-3.586-2.164-1.369-1.369-1.938-2.8-2.163-3.585-.203-.706.06-1.382.493-1.816l.681-.68-2.29-3.368L5.83 5.442C4.79 6.48 4.45 7.934 4.987 9.16c.802 1.834 2.079 4.197 3.867 5.985zm5.183 5.699C12.105 20 9.482 18.603 7.44 16.56 5.397 14.518 4 11.895 3.155 9.962c-.917-2.096-.266-4.408 1.26-5.934L6.38 2.064l1.534.145 3.434 5.051-.12 1.27-1.22 1.22c.182.58.62 1.614 1.625 2.618 1.004 1.004 2.038 1.443 2.618 1.624l1.22-1.22 1.27-.12 5.05 3.435.145 1.534-1.963 1.963c-1.526 1.526-3.838 2.178-5.935 1.261z"}})])
          )
        }
      }
    